<script setup>
import { onBeforeUnmount, onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { getReportAnalysis } from '../../api/reportApi.js'
import AppAlert from '../../shared/components/AppAlert.vue'
import LoadingSpinner from '../../shared/components/LoadingSpinner.vue'

const props = defineProps({ analysisId: { type: String, required: true } })
const router = useRouter()
const status = ref({ status: 'PROCESSING', progress: 0, message: '분석을 시작하고 있습니다.' })
const error = ref('')
let timer

function stopPolling() { if (timer) clearInterval(timer) }
async function sync() {
  try {
    const result = await getReportAnalysis(props.analysisId)
    status.value = { status: result.status || 'PROCESSING', progress: Number(result.progress || 0), message: result.message || '분석을 진행하고 있습니다.' }
    if (result.status === 'COMPLETED') {
      stopPolling()
      if (!result.reportId) throw new Error('완성된 보고서 ID를 받지 못했습니다.')
      router.replace(`/report/${result.reportId}`)
    } else if (result.status === 'FAILED') {
      stopPolling()
      error.value = result.message || '분석에 실패했습니다.'
    }
  } catch (cause) {
    stopPolling()
    error.value = cause.message || '분석 상태를 확인하지 못했습니다.'
  }
}

onMounted(() => { sync(); timer = setInterval(sync, 2000) })
onBeforeUnmount(stopPolling)
</script>

<template>
  <section class="analysis-panel">
    <ol class="step-indicator" aria-label="분석 단계">
<li class="step-item is-done"><span class="step-num" aria-hidden="true">✓</span><div><b>완료</b><span>분석 자료 올리기</span></div></li>
<li class="step-item is-active" aria-current="step"><span class="step-num" aria-hidden="true">2</span><div><b>현재 단계</b><span>AI 교차 분석</span></div></li>
<li class="step-item"><span class="step-num" aria-hidden="true">3</span><div><b>3단계</b><span>PDF 결과 받기</span></div></li>
</ol>
    <div class="analysis-title">
      <!-- <div class="progress-ring" role="progressbar" :aria-valuenow="status.progress" aria-valuemin="0" aria-valuemax="100">
        <svg viewBox="0 0 150 150" aria-hidden="true">
          <circle class="track" cx="75" cy="75" r="62" />
          <circle class="bar" cx="75" cy="75" r="62" pathLength="100" stroke-dasharray="100" :stroke-dashoffset="100 - Math.min(100, status.progress)" />
        </svg>
        <strong>{{ status.progress }}%</strong>
      </div> -->
      <div>
        <p class="home-kicker">2단계 · AI 교차 분석</p>
        <h1>{{ error ? '분석을 끝내지 못했습니다' : '분석하고 있습니다' }}</h1>
        <p class="page-lead">{{ error ? '아래 안내를 확인해 주세요.' : '화면을 닫지 말고 잠시만 기다려 주세요. 끝나면 결과 화면으로 자동으로 넘어갑니다.' }}</p>
      </div>
    </div>
    <p v-if="!error" class="analysis-message" role="status"><LoadingSpinner /> {{ status.message }}</p>
    <AppAlert v-if="error">{{ error }}</AppAlert>
    <div v-if="error" class="upload-actions">
      <span />
      <button type="button" class="app-button app-button--secondary" @click="router.push('/upload')">자료 다시 올리기</button>
    </div>
  </section>
</template>
